export default __webpack_public_path__ + "c880f630520a35d5f1593b39f762efcf.png";